import React from 'react';
import { Ended } from '@components/basics/Badges/UrgencyBadge/Ended';
import { QuantityBadge } from '@components/basics/Badges/UrgencyBadge/QuantityBadge';
import { SoldOut } from '@components/basics/Badges/UrgencyBadge/SoldOut';
import { TextTimerBadge } from '@components/basics/Badges/UrgencyBadge/TextTimerBadge';

export function Badges({
  isOpenEdition,
  isSaleRunning,
  isSoldOut,
  saleEnded,
  isPresale,
  expiryTimestamp,
  totalMinted,
  maxValue,
}: {
  isOpenEdition: boolean;
  isSaleRunning: boolean;
  isSoldOut: boolean;
  saleEnded: boolean;
  isPresale: boolean;
  expiryTimestamp: number;
  totalMinted: number;
  maxValue: number;
}) {
  // Open Edition
  if (isOpenEdition) {
    if (isSaleRunning && !isSoldOut) {
      return <TextTimerBadge label="Ends" expiryTimestamp={expiryTimestamp} />;
    }

    if (isPresale && (saleEnded || isSoldOut)) {
      return <SoldOut />;
    }
  }

  if (isPresale && !isSoldOut) {
    if (saleEnded) {
      return <Ended />;
    }

    if (isSaleRunning) {
      return <TextTimerBadge label="Ends" expiryTimestamp={expiryTimestamp} />;
    }
  }

  // Fixed Edition
  if (isSaleRunning && !isSoldOut) {
    return <QuantityBadge value={totalMinted} maxValue={maxValue} />;
  }

  if (isSoldOut || saleEnded) return <SoldOut />;

  return null;
}
